import React from "react";
import { FormGroup, Label } from "./inputFieldStyle";
import { ErrorMessage, Field } from "formik";
import Message from "../Message/Message";
const InputField = ({ name, label, type, plcaholder, id }) => {
  return (
    <FormGroup>
      <Label htmlFor={name}>{label}</Label>
      <Field id={name} type={type} name={name} plcaholder={plcaholder} />
      <ErrorMessage
        name={id}
        render={(msg) => (
          <Message size="12px" color="red" weight="bold">
            {msg}
          </Message>
        )}
      />
    </FormGroup>
  );
};

export default InputField;
